// extracted by mini-css-extract-plugin
export default {"container":"MarkdownView_container__v8EYg","title":"MarkdownView_title__hmyPU","title__container":"MarkdownView_title__container__ZKAc6","column":"MarkdownView_column__s1AeW"};